import Seo from "../components/Seo";
import { MapPin, FileText, Clock, Users, Euro } from "lucide-react";
import { IMAGES, BEACHVOLLEY, BEACHVOLLEY_PARTNERS, BEACHVOLLEY_TERMS_PDF, BEACHVOLLEY_INFODOSSIER_PDF } from "../data/site";

const programme = [
  { day: "Donderdagavond 16/07", title: "Bedrijventornooi 1", format: "6 vs 6 – gemengde ploegen", image: "https://customer-assets.emergentagent.com/job_mechelen-summer/artifacts/22sv4nje_WhatsApp%20Image%202022-07-29%20at%202.08.46%20PM%20%281%29.jpeg", status: "VOLZET" },
  { day: "Vrijdagavond 17/07", title: "Bedrijventornooi 2", format: "6 vs 6 – gemengde ploegen", image: "https://customer-assets.emergentagent.com/job_mechelen-summer/artifacts/kyk02ynp_Mechelen%20Beach-40%20%281%29.jpg" },
  { day: "Zaterdag 18/07", title: "Recreatief tornooi", format: "6 vs 6 – gemengde ploegen", image: "https://customer-assets.emergentagent.com/job_mechelen-summer/artifacts/ojjsnbpg_Mechelen%20Beach-42%20%281%29%20%281%29.jpg" },
  { day: "Zondag 19/07", title: "Recreatief tornooi 2", format: "6 vs 6 – gemengde ploegen", image: "https://customer-assets.emergentagent.com/job_mechelen-summer/artifacts/efnespw4_WhatsApp%20Image%202022-07-31%20at%205.21.35%20PM%20%281%29.jpeg" },
];

const practical = [
  { icon: Clock, label: "Bedrijventornooien", value: "Donderdag- en vrijdagavond — ca. 17u30 – 23u15" },
  { icon: Clock, label: "Recreatieve tornooien", value: "Zaterdag en zondag — ca. 13u00 – 21u00" },
  { icon: MapPin, label: "Locatie", value: "Douaneplein / Transit M, Mechelen" },
  { icon: Users, label: "Strandbar", value: "Doorlopend geopend met foodtrucks en zomerse sfeer" },
];

const gallery = [
  IMAGES.volleyTeam,
  "https://customer-assets.emergentagent.com/job_mechelen-summer/artifacts/01c0tzc7_481265216_631586586293758_7351160883865797685_n.jpg",
  "https://customer-assets.emergentagent.com/job_mechelen-summer/artifacts/qgtxt923_489921185_18004258307749830_1673319246577492723_n.jpg",
  "https://customer-assets.emergentagent.com/job_mechelen-summer/artifacts/pux2r6hi_502692385_695019233283826_6603976957128579495_n.jpg",
];

export default function Beachvolleybal() {
  return (
    <>
      <Seo
        title="Mechelen Beachvolleybal Tornooi 2026 | 16–19 juli op het Douaneplein"
        description="Mechelen Beachvolleybal Tornooi 2026 van 16/07 t.e.m. 19/07 op het Douaneplein. Bedrijven- en recreatieve tornooien, 6v6 gemengd. Schrijf je ploeg snel in — beperkte plaatsen."
      />

      {/* HERO — two-column layout to match other subpages */}
      <section
        data-testid="beachvolley-hero"
        className="relative overflow-hidden bg-warm-gradient"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
            <div className="animate-fadeup order-2 lg:order-1">
              <span
                data-testid="beachvolley-eyebrow"
                className="inline-flex items-center px-3.5 py-1.5 rounded-full text-xs font-bold uppercase tracking-[0.15em] bg-orange-gradient text-white shadow-md"
              >
                Beachvolleybal · {BEACHVOLLEY.edition}
              </span>
              <h1 className="font-display mt-5 text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight text-[#2b1c10] leading-[1.05]">
                Mechelen Beachvolleybal{" "}
                <span className="text-orange-gradient">Tornooi 2026</span>
              </h1>
              <p
                data-testid="beachvolley-dates"
                className="mt-5 font-display text-xl sm:text-2xl lg:text-3xl font-semibold text-[#2b1c10]"
              >
                {BEACHVOLLEY.dateRange}
              </p>
            </div>

            <div className="relative animate-fadeup order-1 lg:order-2">
              <div className="photo">
                <img
                  src={IMAGES.volleybalHero}
                  alt="Mechelen Beachvolleybal Tornooi 2026 — actie op het zand"
                  className="w-full h-[320px] sm:h-[460px] object-cover"
                  loading="eager"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* INTRO */}
      <section className="bg-[#fdf8ec] py-16 sm:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
            <div className="lg:col-span-5 order-2 lg:order-1">
              <div className="photo aspect-[4/5] sm:aspect-[3/4] lg:aspect-[4/5]">
                <img
                  src="https://customer-assets.emergentagent.com/job_mechelen-summer/artifacts/t1ds4zwq_Mechelen%20Beach-40%20%282%29%20%281%29.jpg"
                  alt="Mechelen Beachvolleybal — officiële sfeerbeelden"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </div>
            <div className="lg:col-span-7 order-1 lg:order-2">
              <span className="eyebrow">Welkom op het zand</span>
              <h2 className="font-display mt-5 text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-[#2b1c10] leading-[1.05]">
                Beachvolley in het hart van Mechelen
              </h2>
              <p className="mt-6 text-base sm:text-lg text-[#6b5945] leading-relaxed">
                Wij heten jullie opnieuw van harte welkom op het Douaneplein / Transit M voor het{" "}
                <span className="font-semibold text-[#2b1c10]">Mechelen Beachvolleybal Tornooi 2026</span>.
                Naast het sportieve tornooi is er tijdens het evenement een gezellige strandbar met
                zomerse sfeer, verfrissende drankjes en lekkere hapjes. Het aantal plaatsen is beperkt,
                dus schrijf je tijdig in.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* PROGRAMMA */}
      <section data-testid="beachvolley-programma" className="bg-sand-2 py-16 sm:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-2xl">
            <span className="eyebrow">Programma</span>
            <h2 className="font-display mt-5 text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-[#2b1c10] leading-[1.05]">
              Programma beachvolley 2026
            </h2>
          </div>

          <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {programme.map((p, i) => (
              <div
                key={p.day}
                data-testid={`programma-day-${i}`}
                className="relative bg-white rounded-2xl border border-[#ebd9b5] overflow-hidden flex flex-col"
              >
                <div className="relative h-44 overflow-hidden">
                  <img
                    src={p.image}
                    alt={`${p.title} — ${p.day}`}
                    className="w-full h-full object-cover transition-transform duration-700 hover:scale-[1.05]"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#2b1c10]/45 via-transparent to-transparent" />
                  {p.status && (
                    <span
                      data-testid={`programma-day-${i}-status`}
                      className="absolute top-3 right-3 inline-flex items-center px-2.5 py-1 rounded-full text-[10px] font-bold uppercase tracking-[0.14em] bg-gradient-to-br from-[#ff5d5d] via-[#ef4444] to-[#c12d2d] text-white shadow-[0_6px_16px_-4px_rgba(239,68,68,0.55)] ring-1 ring-white/40"
                    >
                      {p.status}
                    </span>
                  )}
                </div>
                <div className="p-6 flex-1">
                  <p className="text-xs font-bold uppercase tracking-[0.12em] text-[#ed6a1a]">
                    {p.day}
                  </p>
                  <h3 className="font-display mt-3 text-xl font-semibold text-[#2b1c10] leading-tight">
                    {p.title}
                  </h3>
                  <p className="mt-2 text-sm text-[#6b5945]">{p.format}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* PRAKTISCHE INFO */}
      <section data-testid="beachvolley-praktisch" className="bg-[#fdf8ec] py-16 sm:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
            <div className="lg:col-span-5">
              <span className="eyebrow">Praktisch</span>
              <h2 className="font-display mt-5 text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-[#2b1c10] leading-[1.05]">
                Praktische info
              </h2>
              <p className="mt-5 text-base sm:text-lg text-[#6b5945] leading-relaxed">
                Alles wat je moet weten over het tornooi: timing, locatie en sfeer op het Douaneplein.
              </p>
            </div>
            <div className="lg:col-span-7">
              <div className="bg-white rounded-2xl border border-[#ebd9b5] overflow-hidden">
                {practical.map((row, i) => (
                  <div
                    key={row.label}
                    data-testid={`praktisch-row-${i}`}
                    className={`flex items-start gap-4 px-6 sm:px-8 py-5 ${
                      i !== practical.length - 1 ? "border-b border-[#ebd9b5]" : ""
                    }`}
                  >
                    <span className="mt-0.5 inline-flex h-10 w-10 items-center justify-center rounded-full bg-orange-gradient text-white shrink-0">
                      <row.icon className="h-4 w-4" />
                    </span>
                    <div>
                      <p className="font-semibold text-[#2b1c10]">{row.label}</p>
                      <p className="text-sm text-[#6b5945] leading-relaxed">{row.value}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* TARIEVEN */}
      <section data-testid="beachvolley-tarieven" className="bg-sand-2 py-16 sm:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-2xl">
            <span className="eyebrow">Inschrijven</span>
            <h2 className="font-display mt-5 text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-[#2b1c10] leading-[1.05]">
              Tarieven
            </h2>
          </div>

          <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6">
            <div data-testid="tarief-bedrijven" className="relative bg-white rounded-2xl border border-[#ebd9b5] p-8 sm:p-10 overflow-hidden">
              <span className="absolute top-6 right-6 inline-flex items-center px-3 py-1 rounded-full text-[11px] font-bold uppercase tracking-[0.12em] bg-orange-gradient text-white">
                Bedrijven
              </span>
              <h3 className="font-display text-2xl sm:text-3xl font-semibold text-[#2b1c10]">
                Bedrijventornooi
              </h3>
              <p className="mt-2 text-sm text-[#6b5945]">6 vs 6 — gemengde ploegen</p>
              <div className="mt-6 flex items-baseline gap-2">
                <Euro className="h-6 w-6 text-[#ed6a1a]" />
                <span className="font-display text-5xl font-semibold text-orange-gradient">195</span>
                <span className="text-sm font-semibold text-[#6b5945]">excl. btw / ploeg</span>
              </div>
              <p className="mt-6 text-sm text-[#6b5945] leading-relaxed">
                Donderdag- of vrijdagavond. Sportieve teambuilding gevolgd door drink en sfeer aan de strandbar.
              </p>
            </div>

            <div data-testid="tarief-recreatief" className="relative bg-white rounded-2xl border border-[#ebd9b5] p-8 sm:p-10 overflow-hidden">
              <span className="absolute top-6 right-6 inline-flex items-center px-3 py-1 rounded-full text-[11px] font-bold uppercase tracking-[0.12em] bg-[#2b1c10] text-white">
                Recreatief
              </span>
              <h3 className="font-display text-2xl sm:text-3xl font-semibold text-[#2b1c10]">
                Recreatief tornooi
              </h3>
              <p className="mt-2 text-sm text-[#6b5945]">6 vs 6 — gemengde ploegen</p>
              <div className="mt-6 flex items-baseline gap-2">
                <Euro className="h-6 w-6 text-[#ed6a1a]" />
                <span className="font-display text-5xl font-semibold text-orange-gradient">65</span>
                <span className="text-sm font-semibold text-[#6b5945]">incl. btw / ploeg</span>
              </div>
              <p className="mt-6 text-sm text-[#6b5945] leading-relaxed">
                Zaterdag of zondag. Voor vrienden, familie of collega&apos;s die houden van zand, sport en zon.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* INSCHRIJVEN CTA + DOCUMENTEN */}
      <section data-testid="beachvolley-cta" className="relative bg-[#2b1c10] text-white overflow-hidden">
        <div className="absolute inset-0 opacity-25">
          <img src={IMAGES.volleybal2} alt="" className="w-full h-full object-cover" aria-hidden="true" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#2b1c10] via-[#2b1c10]/85 to-[#2b1c10]/50" />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28">
          <div className="max-w-3xl">
            <span className="inline-flex items-center px-3.5 py-1.5 rounded-full text-xs font-bold uppercase tracking-[0.15em] bg-orange-gradient text-white">
              Inschrijven
            </span>
            <h2 className="font-display mt-5 text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight leading-[1.05]">
              Schrijf je ploeg in
            </h2>
            <p className="mt-5 text-base sm:text-lg text-white/85 leading-relaxed">
              Je inschrijving is pas bevestigd zodra de betaling voldaan is. Het aantal plaatsen is beperkt,
              dus wees er snel bij.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row sm:flex-wrap gap-3">
              <a
                href={BEACHVOLLEY_INFODOSSIER_PDF}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="beachvolley-infodossier"
                className="inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 border border-white/35 text-white font-semibold px-7 py-3.5 rounded-full transition-colors"
              >
                <FileText className="h-4 w-4" />
                Download infodossier beachvolleybal 2026
              </a>

              <a
                href={BEACHVOLLEY_TERMS_PDF}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="beachvolley-voorwaarden"
                className="inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 border border-white/35 text-white font-semibold px-7 py-3.5 rounded-full transition-colors"
              >
                <FileText className="h-4 w-4" />
                Algemene voorwaarden beachvolleybal
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* SFEERBEELDEN */}
      <section data-testid="beachvolley-gallery" className="bg-[#fdf8ec] py-16 sm:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-2xl">
            <span className="eyebrow">Sfeerbeelden</span>
            <h2 className="font-display mt-5 text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-[#2b1c10] leading-[1.05]">
              Tornooi in beeld
            </h2>
          </div>
          <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4">
            {gallery.map((src, i) => (
              <div
                key={i}
                data-testid={`beachvolley-gallery-${i}`}
                className="overflow-hidden rounded-xl aspect-square group"
              >
                <img
                  src={src}
                  alt={`Beachvolley sfeer ${i + 1}`}
                  className="w-full h-full object-cover group-hover:scale-[1.06] transition-transform duration-700"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* PARTNERS BEACHVOLLEY */}
      {BEACHVOLLEY_PARTNERS.some((p) => !!p.logo) && (
        <section data-testid="beachvolley-partners" className="bg-sand-2 py-16 sm:py-24">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <span className="eyebrow">Met steun van</span>
              <h2 className="font-display mt-5 text-3xl sm:text-4xl font-semibold tracking-tight text-[#2b1c10]">
                Partners Beachvolley
              </h2>
            </div>

            {/* Hoofdpartner — Napoleon Score */}
            {BEACHVOLLEY_PARTNERS.filter((p) => p.main && p.logo).map((p) => (
              <div key={p.name} className="mt-10 flex justify-center">
                <a
                  href={p.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`partner-main-${p.name.toLowerCase().replace(/[^a-z]/g, "")}`}
                  title={p.name}
                  className="group relative w-full max-w-xl bg-white rounded-2xl border border-[#ebd9b5] shadow-[0_18px_44px_-18px_rgba(43,28,16,0.22)] px-8 py-10 flex flex-col items-center transition-transform duration-300 hover:-translate-y-0.5"
                >
                  <span className="inline-flex items-center px-3 py-1 rounded-full text-[11px] font-bold uppercase tracking-[0.14em] bg-orange-gradient text-white shadow-md">
                    {p.role}
                  </span>
                  <img
                    src={p.logo}
                    alt={p.name}
                    className="mt-6 max-h-28 sm:max-h-32 w-auto object-contain"
                  />
                </a>
              </div>
            ))}

            {/* Overige partners */}
            <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-4 sm:gap-5">
              {BEACHVOLLEY_PARTNERS.filter((p) => !p.main && p.logo).map((p) => (
                <a
                  key={p.name}
                  href={p.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`partner-${p.name.toLowerCase().replace(/[^a-z]/g, "")}`}
                  title={p.name}
                  className="h-28 sm:h-32 rounded-2xl bg-white border border-[#ebd9b5] flex items-center justify-center p-5 transition-transform duration-300 hover:-translate-y-0.5 hover:shadow-[0_12px_28px_-14px_rgba(43,28,16,0.25)]"
                >
                  <img
                    src={p.logo}
                    alt={p.name}
                    className={`object-contain ${p.small ? "max-h-[65%] max-w-[70%]" : "max-h-full max-w-full"}`}
                  />
                </a>
              ))}
            </div>
          </div>
        </section>
      )}
    </>
  );
}
